<div
  class="promotional-panel-container"
  [ngClass]="[isDisabledController ? 'is-disabled' : '', !isPTPO ? 'primary-account' : 'secondary-account']">
  <div class="promotional-panel">
    <div [ngClass]="[!isPTPO ? 'col-lg-5' : '']" class="col-12 text-container">
      <span class="heading u-heading-4" style="font-size: 23px; color: #13223c"
        ><adp-label [labelKey]="promoSlot?.heading"></adp-label
      ></span>
      <div class="desc u-body-1 promo-text-container">
        <adp-label [labelKey]="promoSlot?.promoText"></adp-label>
        <div class="d-flex align-items-start align-content-center" style="margin-top: 30px">
          <div class="mr-60">
            <p>
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="{{ resourceService.getPortalSetting('URL_GooglePlay_App')?.Value }}"
                class="ng-star-inserted"
                gtmClick="Android Link"
                [gtmLinkURL]="resourceService.getPortalSetting('URL_GooglePlay_App')?.Value"
                ><adp-image [imageKey]="promoSlot?.appleStoreImageKey"></adp-image
              ></a>
            </p>
            <p ifSettingTrue="Dashboard_AppTypePromo_AppleStore_IsEnabled">
              <a
                target="_blank"
                rel="noreferrer noopener"
                href="{{ resourceService.getPortalSetting('URL_AppleStore_App')?.Value }}"
                class="ng-star-inserted"
                gtmClick="IOS Link"
                [gtmLinkURL]="resourceService.getPortalSetting('URL_AppleStore_App')?.Value"
                ><adp-image [imageKey]="promoSlot?.googlePlayImageKey"></adp-image
              ></a>
            </p>
            <p class="apptype-promo-disabled" ifSettingFalse="Dashboard_AppTypePromo_AppleStore_IsEnabled">
              <adp-label labelKey="Dashboard_Promo_AppType_ComingSoon_Text"></adp-label>
              <br />
              <adp-label labelKey="Dashboard_Promo_AppType_AppleStore_Text"></adp-label>
            </p>
          </div>
          <div ifSettingTrue="Dashboard_AppTypePromo_QRCode_IsEnabled" class="d-none d-sm-block text-center">
            <img style="max-width: 100px" [src]="qrCodeImageUrl" [alt]="qrCodeImageAlt" />
            <p><adp-label [labelKey]="promoSlot?.secondaryText"></adp-label></p>
          </div>
        </div>
      </div>
    </div>
    <div [ngClass]="[!isPTPO ? 'col-lg-7' : '']" class="col-12 parent-promotion-container">
      <div>
        <adp-image class="profile-img" aria-hidden="true" [imageKey]="promoSlot?.imageKey"></adp-image>
        <!--<img [src]="imageUrl" [alt]="imageAlt" />-->
        <div class="tech-name-container"></div>
      </div>
    </div>
  </div>
</div>
